var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.7097 54.6408V56.5C76.7072 60.8578 75.2961 65.098 72.6868 68.5883C70.0776 72.0785 66.41 74.6319 62.2311 75.8675C58.0522 77.103 53.5858 76.9547 49.498 75.4445C45.4103 73.9343 41.9203 71.1432 39.5485 67.4874C37.1766 63.8316 36.05 59.5071 36.3368 55.1588C36.6235 50.8105 38.3082 46.6713 41.1395 43.3587C43.9708 40.046 47.7971 37.7373 52.0478 36.777C56.2984 35.8166 60.7456 36.256 64.7261 38.0296M76.7097 40.3333L56.5013 60.5619L50.4388 54.4994",
    stroke: "#039855",
    strokeWidth: 4.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 97,
    height: 97,
    rx: 48.5,
    stroke: "#ECFDF3",
    strokeWidth: 14.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.78edf667de81fffbe1bccf34565f4220.svg";
export { ForwardRef as ReactComponent };